import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import img from "../../assets/ForgotPasswordImg.png";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function ResetPassword() {
  const { token } = useParams();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [tokenValid, setTokenValid] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const response = await axios.get(
        `${ApiConnectionString}/api/forgotpassword/${token}`
      );

      if (response.status == 200) {
        setTokenValid(response.data);
      }
    } catch (error) {
      console.error(error);
      setTokenValid(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (password.length < 8) {
      setError("Password must be at least eight characters");
      return;
    }

    if (!/\d/.test(password)) {
      setError("Password must include at least one number");
      return;
    }

    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }

    try {
      const response = await axios.put(
        `${ApiConnectionString}/api/resetpassword`,
        {
          token: token,
          password: password,
        }
      );

      if (response.status === 200) {
        setSuccess("Your password has been reset successfully");
      }
    } catch (err) {
      setError("Something went wrong, please try again");
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  if (!tokenValid) {
    return (
      <div className="py-5 text-center">
        <div className="container">
          <h1 className="display-5 fw-bold brand-dark-purple mb-3">
            Token is not valid
          </h1>
          <p className="lead brand-dark-purple">
            Please try to reset your password again.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h1 className="display-4 fw-bold brand-dark-purple mb-3">
              Reset Password
            </h1>

            {error && <p className="text-danger mb-3">{error}</p>}
            {success && <p className="text-success mb-3">{success}</p>}

            {!success && (
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label brand-dark-purple">
                    New password
                  </label>

                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Enter new password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />

                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>

                <div className="mb-4">
                  <label className="form-label brand-dark-purple">
                    Confirm new password
                  </label>

                  <div className="input-group">
                    <input
                      type={showConfirm ? "text" : "password"}
                      className="form-control"
                      placeholder="Confirm new password"
                      value={confirm}
                      onChange={(e) => setConfirm(e.target.value)}
                    />

                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowConfirm(!showConfirm)}
                    >
                      {showConfirm ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-lg brand-purple-inline w-100 w-md-auto"
                >
                  Reset Password
                </button>
              </form>
            )}
          </div>

          <div className="col-lg-6 text-center">
            <img
              src={img}
              alt="Reset password illustration"
              className="illustration-img"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
